import { isEmpty, noop } from 'lodash';
import { useCallback } from 'react';

import { ICD10Disease } from '@dreryk/egabinet-icd-dictionary-frontend-api';

import { FieldControllerProps } from '@dreryk/react-common';
import { useInteractiveTableContext } from '@dreryk/react-components';

import { DiseaseSelection } from '../../../../shared/autossugest/DiseaseAutosuggest.types';
import { DiseaseSelector } from '../../../../shared/selector/DiseaseSelector';
import { DiagnosesWithBodySideTableBean } from '../DiagnosesWithBodySideInteractiveTable.types';

type DiseaseWithBodySideAutosuggestProps = FieldControllerProps<`${string}.selection`, ICD10Disease> & {
   readonly dictionaryValidOn: Date;
   readonly defaultItems?: ICD10Disease[];
};

export const DiseaseWithBodySideAutosuggest = (props: DiseaseWithBodySideAutosuggestProps): JSX.Element => {
   const { addRow, getValues } = useInteractiveTableContext<DiagnosesWithBodySideTableBean>();

   const handleSelectionChange = useCallback(
      (selectedDisease: DiseaseSelection): void => {
         if (!selectedDisease) {
            return noop();
         }

         const currentDiagnoses = getValues();

         const diseaseAlreadySelected = currentDiagnoses.some((diagnosis) => diagnosis.code === selectedDisease.code);
         if (diseaseAlreadySelected) {
            return noop();
         }

         return addRow(
            {
               code: selectedDisease.code,
               name: selectedDisease.name,
               main: isEmpty(currentDiagnoses),
               bodySide: {
                  left: false,
                  right: false,
               },
            },
            'prepend'
         );
      },
      [addRow, getValues]
   );

   return <DiseaseSelector {...props} onSelectionChange={handleSelectionChange} />;
};
